import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import InputLabel from '@mui/material/InputLabel';
import React from "react";
import FormControl from "@mui/material/FormControl";

export default function  ObjecttypeSelectlist ({options, selected, handleChange, label, style}) {

    // const options = [
    //     {value: '', text: '-- Bitte wählen Sie einen Objekttypen --'},
    //     {value: 'territorialdivision', text: 'Gebietsgliederung'},
    //     {value: 'site', text: 'Liegenschaft'},
    //     {value: 'economicunit', text: 'Wirtschaftseinheit'},
    //     {value: 'structure', text: 'Bauwerk'},
    //     {value: 'building', text: 'Gebäude'},
    //     {value: 'storey', text: 'Geschoß'},
    //     {value: 'buildingentrance', text: 'Hauseingang'},
    //     {value: 'rentalunit', text: 'Mieteinheit'},
    //     {value: 'commercialunit', text: 'Gewerbeeinheit'},
    //     {value: 'apartment', text: 'Wohnung'},
    //     {value: 'room', text: 'Raum'},
    //     {value: 'playground', text: 'Spielplatz'},
    //     {value: 'parkingspace', text: 'Stellplatz'},
    // ];

    return (
        <>
            <FormControl sx={{ m: 1, minWidth: 120 }}>
            {label ? (
                <InputLabel id="objecttype-select-label">{label}</InputLabel>
                ): null}
            <Select
                id="objecttype-select"
                labelId="objecttype-select-label"
                label={label}
                value={selected} onChange={handleChange}

                sx={style}>
                {options?.map(option => (
                    <MenuItem key={option.value} value={option.value}>
                        {option.text}
                    </MenuItem>
                ))}
            </Select>
            </FormControl>
        </>
    )
}